export default [
	{
		path: "/admin/redirects",
		exact: true,
		policy: "superAdminAuth",
		component: "AdminRedirects",
		mui: true,
	},
];
